import e from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const d = {
  display: "block"
}, f = ({ size: t = 16, useVw: l, useRem: c, color: n, withColor: o, removeClassName: a, disableSSR: m, style: i, ...p }) => {
  const v = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ e.createElement(x, { disableSSR: m }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "32px-shenji", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: l ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (c ? "rem" : "px"), height: l ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (c ? "rem" : "px"), className: a ? "" : "iconpark-icon", style: v, fill: "none", ...p }, /* @__PURE__ */ e.createElement(
    "g",
    {
      className: a ? "" : "32px-å®¡è®¡"
    },
    /* @__PURE__ */ e.createElement(
      "g",
      {
        className: a ? "" : "normal",
        fill: o ? r(n, 0, "#262933") : "#262933",
        datafollowfill: o ? r(n, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "m22.042 13.132-6.666 6.25a.9.9 0 0 1-1.231 0l-3.334-3.125a.9.9 0 0 1 1.231-1.314l2.718 2.548 6.051-5.672a.9.9 0 0 1 1.231 1.313Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M18.71 3.783a7.184 7.184 0 0 0-5.418 0L6.546 6.544c-.667.27-1.218.78-1.6 1.348-.382.568-.645 1.27-.645 1.981v5.319c0 6.343 4.585 12.236 10.836 13.963h.003a3.275 3.275 0 0 0 1.71 0h.002c6.251-1.727 10.836-7.62 10.837-13.962v-.001l.012-5.317v-.002c0-.715-.269-1.417-.651-1.983-.383-.566-.933-1.076-1.593-1.345L18.71 3.783Zm-4.737 1.666a5.384 5.384 0 0 1 4.056 0l6.748 2.762c.26.107.552.347.781.687.23.339.343.696.343.974v.001l-.012 5.317v.002c0 5.504-4.016 10.707-9.514 12.227a1.476 1.476 0 0 1-.76 0C10.116 25.9 6.1 20.696 6.1 15.192V9.873c0-.281.112-.64.339-.977.227-.337.516-.577.78-.683l.006-.002 6.747-2.762Z",
          fillRule: "evenodd"
        }
      )
    )
  )));
}, g = f;
export {
  g as default
};
